<script setup lang="ts">
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';
import { RouterLink } from 'vue-router';
import { setup, type Props, type Emit } from './breadCrumbsButton.setup';

const props = defineProps<Props>();

const emit = defineEmits<Emit>();

const { buttonClass, onMouseEnter, onMouseClick, onMouseLeave } = setup(props, emit);
</script>

<template>
  <router-link
    v-if="props.to"
    :class="buttonClass"
    :to="props.to"
  >
    <span><slot /></span>
  </router-link>
  <base-button
    v-else
    tag="button"
    type="button"
    :class="buttonClass"
    :data-bread-crumb-id="breadCrumbId"
    @mouseover="onMouseEnter"
    @click="onMouseClick"
    @mouseleave="onMouseLeave"
  >
    <span><slot /></span>
    <ev-icon icon="icon-arrow-down" />
  </base-button>
</template>

<style lang="scss" scoped>
.path-button {
  display: inline-flex;
  position: relative;
  align-items: center;
  max-width: 320px;
  padding: 2px 2px 2px 6px;
  cursor: pointer;
  border-radius: 2px;
  background-color: transparent;
  font-size: inherit;
  line-height: inherit;
  color: var(--main-font-color);

  span {
    display: inline-block;
    flex: 1;
    overflow: hidden;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  i {
    pointer-events: none;
    background-color: var(--main-font-color);
    transition: transform $animate-base;
  }

  &--active,
  &:active {
    background-color: var(--app-header-path-active-bg-color);

    i {
      transform: rotate(-180deg);
    }
  }

  &:hover:not(&--active, &:active) {
    background-color: var(--app-header-path-hover-bg-color);
  }
}
</style>
